import React, { useState } from "react";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { useTranslation } from "react-i18next";
import wlLogo from "../../img/icons/welocate-bl.svg";
import AfspraakModal from "./AfspraakModal";
import "./MaatwerkResultaten.css";

const AdvisorWidget = ({ standalone = false, className = "" }) => {
  const { t } = useTranslation();
  const [showAfspraakModal, setShowAfspraakModal] = useState(false);

  return (
    <React.Fragment>
      <div
        className={`summary-advisor-widget${standalone ? " standalone" : ""}${
          className ? ` ${className}` : ""
        }`}
      >
        <div className="summary-advisor-header">
          <SupportAgentIcon sx={{ color: "#439BD9", fontSize: "22px" }} />
          <h4>{t("besprekMetMakelaarTitel")}</h4>
        </div>
        <span>{t("besprekMetMakelaarText")}</span>
        <span>{t("afspraakText")}</span>
        <button
          type="button"
          className="summary-advisor-btn"
          onClick={() => setShowAfspraakModal(true)}
        >
          <CalendarMonthIcon sx={{ fontSize: "18px" }} />
          {t("afspraakButton")}
        </button>
        <div className="summary-advisor-partner">
          <span>{t("afspraakPartner")}</span>
          <img src={wlLogo} alt="Welocate" />
        </div>
      </div>
      <AfspraakModal
        visible={showAfspraakModal}
        setVisible={setShowAfspraakModal}
      />
    </React.Fragment>
  );
};

export default AdvisorWidget;
